import { Component } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import {
  UntypedFormGroup,
  UntypedFormControl,
  UntypedFormBuilder,
  Validators,
} from "@angular/forms";
import { CustomValidators } from "ng2-validation";

import { ChangePasswordModel } from "../models/change-password.model";
import { BaseFormComponent } from "../../../shared/components/base-form.component";
import { Messages } from "../../../shared/constants/messages.constant";
import { RecoveryService } from "../services/recovery.service";

@Component({
  selector: "change-password",
  templateUrl: "../templates/change-password.html",
  styleUrls: ["../scss/change-password.scss"],
})
export class ChangePasswordComponent extends BaseFormComponent {
  changePassword: ChangePasswordModel;
  errors: Array<string>;
  success: Array<string>;
  isUser: boolean = true;
  showLoading: boolean;

  constructor(
    private fb: UntypedFormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private recoveryService: RecoveryService
  ) {
    super(
      { email: "", old_password: "", password: "", password_confirmation: "" },
      {
        email: {
          required: Messages.EMAIL_REQUIRED,
          email: Messages.EMAIL_REQUIRED,
        },
        old_password: {
          required: Messages.CURRENT_PASSWORD_REQUIRED,
          minlength: Messages.PASSWORD_MINLENGTH,
        },
        password: {
          required: Messages.PASSWORD_REQUIRED,
          minlength: Messages.PASSWORD_MINLENGTH,
        },
        password_confirmation: {
          equalTo: Messages.PASSWORD_EQUAL,
        },
      },
      fb
    );

    this.changePassword = new ChangePasswordModel();
  }

  ngOnInit() {
    this.buildForm();
  }

  initializeForm(): UntypedFormGroup {
    let password: UntypedFormControl = new UntypedFormControl(this.changePassword.password, [
      Validators.required,
      Validators.minLength(6),
    ]);
    let password_confirmation: UntypedFormControl = new UntypedFormControl(
      this.changePassword.password_confirmation,
      CustomValidators.equalTo(password)
    );

    return this.fb.group({
      old_password: [
        this.changePassword.old_password,
        Validators.compose([Validators.required, Validators.minLength(6)]),
      ],
      password: password,
      password_confirmation: password_confirmation,
    });
  }

  sendForm(): any {
    let values = this.form.value;
    this.showLoading = true;
    this.changePassword = this.form.value;
    this.route.params.subscribe((params: any) => {
      this.changePassword.token = params["token"];
    });
    return this.recoveryService
      .changePassword(
        values.old_password,
        values.password,
        values.password_confirmation
      )
      .subscribe(
        (res) => {
          this.handleSuccess(res);
        },
        (res) => {
          this.handleErrors(res);
        }
      );
  }

  handleSuccess(res: any) {
    this.errors = [];
    this.success = res.messages;
    setTimeout(() => {
      this.router.navigate(["login"]);
    }, 3000);
  }

  handleErrors(errors) {
    this.success = [];
    this.errors = [];
    this.success = [];
    this.errors = errors.messages;
    this.showLoading = false;
    console.error(errors);
  }
}
